import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import RtwProductType from "./actionTypes"

import RtwProductAction from "./actions"
import moment from "moment"
import RtwProductAPI from "helpers/rtw_product_backend_helper"

// get global state
export const getState = ({ Users }) => Users

function* fetchListOnPage({ payload }) {
  yield put(
    RtwProductAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(RtwProductAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      RtwProductAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      RtwProductAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    RtwProductAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(RtwProductAPI.getDetail, payload.id)

    action(data)
    yield put(
      RtwProductAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      RtwProductAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostData({ payload, action }) {
  yield put(
    RtwProductAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(RtwProductAPI.postData, payload)

    yield put(
      RtwProductAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      RtwProductAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    RtwProductAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(RtwProductAPI.putData, payload)

    yield put(
      RtwProductAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      RtwProductAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* rtwProductSaga() {
  yield takeEvery(RtwProductType.GET_RTW_PRODUCT_PAGES, fetchListOnPage)
  yield takeEvery(RtwProductType.GET_DETAIL_RTW_PRODUCT_BY_ID, fetchDetail)
  yield takeEvery(RtwProductType.POST_RTW_PRODUCT, fetchPostData)
  yield takeEvery(RtwProductType.PUT_RTW_PRODUCT, fetchPutData)
}

export default rtwProductSaga
